// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "call_window_limit.proto" (syntax proto3)
// tslint:disable
import { CallWindowLimitService } from "./call_window_limit";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service CallWindowLimitService
 */
export class CallWindowLimitServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = CallWindowLimitService.typeName;
        this.methods = CallWindowLimitService.methods;
        this.options = CallWindowLimitService.options;
    }
    /**
     * @generated from protobuf rpc: CreateCallWindowLimit
     */
    createCallWindowLimit(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCallWindowLimit
     */
    getCallWindowLimit(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetCallWindowLimit
     */
    batchGetCallWindowLimit(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateCallWindowLimit
     */
    updateCallWindowLimit(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteCallWindowLimit
     */
    deleteCallWindowLimit(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
